import { ScheduleState } from "../../../type/schedule-state";

interface Action {
  type: string;
  payload: {
    dateToWork: string;
  };
}

export const setDateToWorkDispatch = (state: ScheduleState, action: Action) => {
  const { dateToWork } = action.payload;
  state.dateToWork = dateToWork;
};
